import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["onClick", "enabled", "label"];
import styled from 'styled-components';
import isValidI18nKey from 'I18n/utils/isValidI18nKey';
import { useCurrentStep } from '../hooks/useCurrentStep';
import { useIsStepDataValid } from '../hooks/useIsStepDataValid';
import { Step } from 'signup-constants/Step';
import CreateAccountTermsOfService from './CreateAccountTermsOfService';
import { usePrivacyBanner } from './usePrivacyBanner';
import { devices } from 'signup-constants/styles/viewports.styles';
import { NextButton } from 'signup-components/components/NextButton/NextButton';
import { getStepConfig } from '../views/getStepConfig';
import { useLayoutTemplate } from '../hooks/useLayoutTemplate';
import { LayoutType } from 'signup-components/types';
import { isLeftAlignedLayout } from '../utils/isLeftAlignedLayout';
import { useSelector } from 'react-redux';
import { getIsAccountCreationStep } from '../flow-management/getIsAccountCreationStep';
import { getNextSteps } from '../store/flow/selectors';
import HubletLocation from './HubletLocation';
import { Text } from 'foundations-components/components/Text';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const StyledNextButtonWrapper = styled.div.withConfig({
  displayName: "NextButtonWrapper__StyledNextButtonWrapper",
  componentId: "sc-5kgt8d-0"
})(["", " @media ", "{top:0;padding-top:", ";}@media ", "{", "}@media ", "{", "}"], props => ![Step.LandingPage, Step.OptionalPhoneNumber].includes(props.$currentStep) && `top: 0;
    padding-top: ${props.theme.space['400']};
    position: relative;`, devices.desktop, props => props.$layoutType !== LayoutType.FramedCentredModalStep && props.$currentStep !== Step.LandingPage ? props.theme.space['700'] : '', devices.desktop, props => props.$currentStep !== Step.LandingPage && isLeftAlignedLayout(props.$layoutType) && 'width: 420px;', devices.tablet, props => props.$currentStep !== Step.LandingPage && isLeftAlignedLayout(props.$layoutType) && `padding-top: ${props.theme.space['1000']};`);
const NextButtonWrapper = _ref => {
  let {
      onClick,
      enabled,
      label
    } = _ref,
    props = _objectWithoutPropertiesLoose(_ref, _excluded);
  const {
    shouldShowToSNonOptionalStep,
    shouldShowToSOptionalStep
  } = usePrivacyBanner();
  const {
    currentStep
  } = useCurrentStep();
  const customButtonLabelI18n = `views.${currentStep}.buttonLabel`;
  const isStepDataValid = useIsStepDataValid(currentStep);
  const stepConfig = getStepConfig(currentStep);
  const {
    layoutType
  } = useLayoutTemplate();
  const isEnabled = typeof enabled === 'boolean' ? enabled : isStepDataValid;
  const isAccountCreationStep = useSelector(state => getIsAccountCreationStep(state, getNextSteps(state)));
  const showCreateAccountLabel = currentStep === Step.CmsSignupIntent || isAccountCreationStep;
  let buttonLabel =
  // eslint-disable-next-line no-nested-ternary
  label && isValidI18nKey(label) ? label : isValidI18nKey(customButtonLabelI18n) ? customButtonLabelI18n : 'button.next';
  const showCreateAccountText = shouldShowToSNonOptionalStep || shouldShowToSOptionalStep || showCreateAccountLabel;
  if (showCreateAccountText) {
    buttonLabel = 'button.createAccount';
  }
  const onSubmit = event => {
    event.preventDefault();
    onClick();
  };
  const shouldShowIcon = stepConfig && stepConfig.showNextButtonIcon && !showCreateAccountText;
  const dataSeleniumAttr = `${currentStep}_button`;
  const shouldShowToSOptionalPhonenumber = shouldShowToSOptionalStep && currentStep === Step.OptionalPhoneNumber;
  const shouldShowTermsOfService = shouldShowToSNonOptionalStep || shouldShowToSOptionalPhonenumber;
  if (layoutType === LayoutType.SidePanel && currentStep !== Step.LandingPage) {
    return null;
  }
  return (
    /*#__PURE__*/
    //@bend-expect trellis-tokenized
    _jsxs(StyledNextButtonWrapper
    // @ts-expect-error Expression produces a union type that is too complex to represent.
    , {
      $currentStep: currentStep,
      $layoutType: layoutType,
      children: [/*#__PURE__*/_jsx(NextButton, Object.assign({
        buttonLabel: buttonLabel,
        dataSelenium: dataSeleniumAttr,
        isEnabled: isEnabled,
        label: buttonLabel,
        showIcon: shouldShowIcon,
        onClick: onSubmit
      }, props)), !shouldShowTermsOfService && showCreateAccountText && /*#__PURE__*/_jsx(Text, {
        as: "div",
        marginBlockStart: "500",
        textAlign: "center",
        children: /*#__PURE__*/_jsx(HubletLocation, {})
      }), shouldShowTermsOfService && /*#__PURE__*/_jsx(CreateAccountTermsOfService, {
        hideBorder: shouldShowToSOptionalPhonenumber
      })]
    })
  );
};
export default NextButtonWrapper;